import React, { useEffect, useState } from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import Splash from '../splash';

const SplashWrapper = ({ children, minSplashTime = 2000 }) => {
  const { isAnyLoading, isSplashVisible, hideSplash } = useLoading();
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);

  // Ensure splash shows for minimum time
  useEffect(() => {
    const timer = setTimeout(() => {
      setMinTimeElapsed(true);
    }, minSplashTime);

    return () => clearTimeout(timer);
  }, [minSplashTime]);

  // Hide splash when both minimum time has elapsed AND no components are loading
  useEffect(() => {
    if (minTimeElapsed && !isAnyLoading) {
      const hideTimer = setTimeout(() => {
        hideSplash();
      }, 200); // Small delay for smooth transition

      return () => clearTimeout(hideTimer);
    }
  }, [minTimeElapsed, isAnyLoading, hideSplash]);

  return (
    <>
      <Splash splashEnded={!isSplashVisible} />
      <div style={{ display: isSplashVisible ? 'none' : 'block' }}>
        {children}
      </div>
    </>
  );
};

export default SplashWrapper;
